import { ApiUtils } from './api.util';
import { observeContentResize } from './resizeObserver';
var rootElement = document.getElementById('rootElem');
observeContentResize(rootElement, function (_a) {
    var height = _a.height;
    ApiUtils.emitMessage({
        messageType: 'onHeightChange',
        payload: { height: height },
    });
});
